export default __webpack_public_path__ + "static/media/MeloCreo.4d0693f9.png";